<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :class="eventType === 'view' ? 'h550_dialog abow_dialog' : 'h800_dialog abow_dialog'"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="所属省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="所属城市"
                    prop="cityId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.cityId"
                      filterable
                      clearable
                      placeholder="请选择城市"
                      style="width:100%"
                      @change="changeCityFun"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="物料收货人"
                    prop="receiverId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.receiverId"
                      filterable
                      clearable
                      placeholder="请选择物料收货人"
                      style="width:100%"
                      @change="changeReceiverFun"
                    >
                      <el-option
                        v-for="item in receiverOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.receiverName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="物料收货地址"
                    prop="receiveAddress"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.receiveAddress"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="固定资产库房"
                    required
                  >
                    <el-radio-group
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.isFixedAsset"
                    >
                      <el-radio
                        :label="1"
                      >
                        是
                      </el-radio>
                      <el-radio
                        :label="2"
                      >
                        否
                      </el-radio>
                    </el-radio-group>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.isFixedAssetValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="默认库房"
                    required
                  >
                    <el-radio-group
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.isDefault"
                    >
                      <el-radio
                        :label="1"
                      >
                        是
                      </el-radio>
                      <el-radio
                        :label="0"
                      >
                        否
                      </el-radio>
                    </el-radio-group>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.isDefaultStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              管理员信息
            </h3>
            <div class="modal-row-box">
              <el-row
                v-if="eventType !== 'view'"
                :gutter="10"
              >
                <el-col :span="11">
                  <div class="search-box">
                    <el-input
                      v-model="userFilterText"
                      placeholder="查询用户"
                    />
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in userData"
                        :key="item.index"
                        :class="{'active':index==userCurrent}"
                        @dblclick="addToSetList(item, index)"
                        @click="userCheckedFun(item, index)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>

                <el-col :span="2">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetUserFun"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteSetUserFun"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>

                <el-col :span="11">
                  <div class="right">
                    <ul class="right-list">
                      <li class="employee">
                        管理员
                      </li>
                    </ul>
                    <div class="right-list-box">
                      <ul>
                        <draggable
                          :list="setUserData"
                          group="article"
                          class="dragArea"
                        >
                          <div
                            v-for="(element, index) in setUserData"
                            :key="index"
                            class="list-complete-item"
                            :class="{'active':index==setUserCurrent}"
                            @dblclick="deleteToSetList(element, index)"
                            @click="flowCheckedFun(element, index)"
                          >
                            <li class="employee">
                              {{ element.name }}
                            </li>
                          </div>
                        </draggable>
                      </ul>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-else
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      v-model="dialogAddEditViewForm.manageNames"
                      type="textarea"
                      style="margin-top:10px;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadUserSelectDataByUserTypeApi } from '@/api/user'
import { initDepotApi, saveOrUpdateDepotApi } from '@/api/depot'
export default {
  components: { draggable },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        receiverId: [{ required: true, message: '请选择物料收货人', trigger: 'change' }],
        receiveAddress: [{ required: true, message: '请输入收货地址', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      receiverOptions: [],
      userFilterText: '', // 职员集合过滤文字
      userData: [], // 职员数据源
      constUserData: [],
      userChecked: null,
      userCurrent: -1,
      setUserData: [],
      setUserChecked: null,
      setUserCurrent: -1
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.provinceOptions = []
        this.cityOptions = []
        this.receiverOptions = []
        this.userFilterText = ''
        this.constUserData = []
        this.userChecked = null
        this.userCurrent = -1
        this.setUserData = []
        this.setUserChecked = null
        this.setUserCurrent = -1
        this.dialogAddEditViewForm = {
          name: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          manageIds: '',
          manageNames: '',
          receiverName: '',
          receiverId: '',
          receiveAddress: '',
          isFixedAsset: 2,
          isFixedAssetValue: '',
          isDefault: 0,
          isDefaultStr: '',
          remark: ''
        }
        if (this.eventType !== 'view') {
          this.initProvinceSelectData()
          this.getUserData()
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        }
      }
    },
    userFilterText (val) {
      this.userData = this.constUserData.filter(list => {
        return list.name.indexOf(val) !== -1
      })
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initDepotApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        if (this.eventType !== 'view') {
          this.initCitySelectData(data.provinceId)
        }
        let manageNameArray = data.manageNames.split(',')
        data.manageIds.split(',').forEach((item, index) => {
          this.setUserData.push({ id: item, name: manageNameArray[index] })
        })
        this.loading = false
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.dialogAddEditViewForm.cityName = ''
      this.dialogAddEditViewForm.cityId = null
      this.initCitySelectData(val)
    },
    // 初始城市下拉数据
    initCitySelectData (val) {
      loadAreaDataApi({ parentId: val, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.cityName = selectItem ? selectItem.label : ''
    },
    // 选择收货人回调
    changeReceiverFun (val) {
      let selectItem = {}
      selectItem = this.receiverOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.receiverName = selectItem ? selectItem.label : ''
    },
    // 获取职员清单
    getUserData () {
      loadUserSelectDataByUserTypeApi().then(response => {
        const { data } = response
        this.userData = data
        this.constUserData = data
        this.receiverOptions = data
        this.receiverOptions.forEach(item => {
          item.label = item.name
          item.data = item.id
        })
        this.userChecked = null
        this.userCurrent = -1
        if (this.eventType === 'add') {
          this.loading = false
        }
      })
    },
    userCheckedFun (item, index) {
      this.userCurrent = index
      this.userChecked = item
    },
    flowCheckedFun (item, index) {
      this.setUserCurrent = index
      this.setUserChecked = item
    },
    addSetUserFun () {
      if (!this.userChecked) {
        this.$message.error('请选择要添加的用户')
        return
      }
      let hasItem = false
      this.setUserData.forEach(item => {
        if (item.id === this.userChecked.id) {
          hasItem = true
        }
      })
      if (!hasItem) {
        this.setUserData.push(this.userChecked)
      }
    },
    deleteSetUserFun () {
      if (!this.setUserChecked) {
        this.$message.error('请选择要删除的用户')
        return
      }
      let index = this.setUserData.indexOf(this.setUserChecked)
      if (index >= 0) {
        this.setUserCurrent = -1
        this.setUserData.splice(index, 1)
      }
    },
    addToSetList (item, index) {
      this.userCheckedFun(item, index)
      this.addSetUserFun()
    },
    deleteToSetList (item, index) {
      this.flowCheckedFun(item, index)
      this.deleteSetUserFun()
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          if (this.setUserData.length < 1) {
            this.$message.error('请选择管理员')
            return false
          } else {
            let manageIds = ''
            let manageNames = ''
            this.setUserData.forEach(item => {
              manageIds += ',' + item.id
              manageNames += ',' + item.name
            })
            manageIds = manageIds.substring(1)
            manageNames = manageNames.substring(1)
            this.dialogAddEditViewForm.manageIds = manageIds
            this.dialogAddEditViewForm.manageNames = manageNames
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '仓库', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateDepotApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.search-box {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 10px;
}
.left {
  width: 100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.right {
  width: 100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-top: 48px;
  margin-bottom: 10px;
}
.left {
  padding: 5px 0;
}
.left li {
  padding: 0 5px;
}
.left-list-box {
  overflow-x: hidden;
  overflow: auto;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 20px;
}
.transfer-button {
  width: 70px;
  float: left;
  padding-top: 120px;
  text-align: center;
}
.transfer-button .el-button {
  margin: 10px 0;
  flex: 1;
}
.right {
  width: 100%;
}
.right-list,
.list-complete-item {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  display: flex;
  overflow-x: hidden;
}
.right-list li,
.list-complete-item li {
  padding: 0 5px;
  margin: 0;
  line-height: 24px;
  border-bottom: 1px solid #e6ebf5;
  flex: 1;
}
li.order {
  flex: 0 1 60px;
  width: 60px;
  border-right: 1px solid #e6ebf5;
}
li.employee {
  border-right: 1px solid #e6ebf5;
  text-align: center;
}
.right-list > li {
  background: #efefef;
}
.li:hover {
  background: #b2e1ff;
}
.active {
  background: #7fceff;
}
.right-list-box {
  height: 224px;
  overflow-x: hidden;
  overflow: auto;
}
</style>
